module.exports = __webpack_public_path__ + "media/application/images/eu-cyber-small-logo-3f3eb26afe19395d6799a3b8b8cc7537.svg";